<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 路由守卫，用于更新页面标题和meta标签
    this.$router.beforeEach((to, from, next) => {
      // 更新页面标题
      if (to.meta.title) {
        document.title = to.meta.title;
      }
      
      // 更新页面描述
      if (to.meta.description) {
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', to.meta.description);
        }
      }
      
      next();
    });
  }
}
</script>

<style>
/* 导入全局样式 */
@import './assets/style.css';

/* 全局动画样式 */
@import './assets/css/animations.css';

/* 全局重置样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  background-color: #f5f5f5;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 滚动条样式优化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>




// WEBPACK FOOTER //
// src/App.vue